


EMRAdmin.factory('CommonLargeLocalStorageFactory', ['$q', '$rootScope', '$filter', 'AuditLogService', '$http', '$state', function ($q, $rootScope, $filter, AuditLogService, $http, $state) {

    var storage;
    var desiredCapacity = 100 * 1024 * 1024; //100MB

    var IsLocalStorageNotInitialized = false;

    var SchedulersDBCurVersionNumber = 'SchedulerVersionInfo^' + GetCurrentLoadedEHRVersionNumber();
    var SchedulertemplateTitle = 'Schedulertemplate^';
    var SchedulertemplateGroupTheraphyTitle = 'Schedulergrouptheraphytemplate^';
    var SchedulerSettingsTitle = 'Schedulertemplatesettings^';
    //var SchedulertemplateGoldenThreadCustFields = 'SchedulertemplateGoldenThreadCustomizationFields^';
    var SchedulertemplateCustomOptions = 'Schedulertemplatecustomoptions^';
    var SchedulerDataObjectPropertiesdetails = 'SchedulerDataObjectPropertiesdetails^';
    var NoDataFromDataBase = 'NODATAFROMDATABASE';

    try {
        if (window.navigator.vendor.toLowerCase().indexOf("apple") >= 0 || EHRisMobile.iOS())
            IsLocalStorageNotInitialized = true;
    } catch (e) {

    }

    var CommonLargeLocalStorageFactoryInstance = {



        getStorageName: function (ModuleStorageName) {
            return ModuleStorageName + '_' + EMRPracticeModel.PracticeID;//CREATING DB PER PRACTICE
        },

        //============================================================ LLS START =========================================================================

        InitializeEHRLocalStorage: function (ModuleStorageName) {


            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.reject();
                });
            }
            else {
                //APENDING VERSION NUMBER
                ModuleStorageName = CommonLargeLocalStorageFactoryInstance.getStorageName(ModuleStorageName);

                storage = new LargeLocalStorage({

                    size: desiredCapacity,// desired capacity, in bytes.

                    // optional name for your LLS database. Defaults to lls.
                    // This is the name given to the underlying
                    // IndexedDB or WebSQL DB or FSAPI Folder.
                    // LLS's with different names are independent.
                    name: ModuleStorageName

                    // the following is an optional param 
                    // that is useful for debugging.
                    // force LLS to use a specific storage implementation
                    // forceProvider: 'IndexedDB' or 'WebSQL' or 'FilesystemAPI'
                });

                storage.initialized.then(function (capacity) {

                    //console.log(capacity);
                    if (capacity != -1 && capacity != desiredCapacity) {
                        // the user didn't authorize your storage request
                        // so instead you have some limitation on your storage
                    }

                    if (storage.ready()) {
                        //CHECK VERSION INFO
                        CommonLargeLocalStorageFactoryInstance.CheckLocalStorageVersion().then(function (serviceResponse) {
                            deferred.resolve("success");
                        });
                    }
                });
            }

            return deferred.promise;
        },

        hasValueInLLS: function (inputValue) {
            if (!hasValue(inputValue)) {
                return false;
            }

            if (typeof inputValue == "string" && (inputValue.toString().trim().toUpperCase() == NoDataFromDataBase.trim())) {
                inputValue = null;
                return true;
            } else {
                return true;
            }
        },

        // ============================================================================= SET CONTNET FROM LOCAL STORAGE START ===========================
        SetContentInEHRLocalStorage: function (docId, docData) {

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                return;
            }

            if (storage.ready()) {

                if (hasValue(docData)) {
                    docData = LZString144.compressToUTF16(JSON.stringify(docData));
                }
                else {
                    docData = NoDataFromDataBase;
                }

                storage.setContents(CommonLargeLocalStorageFactoryInstance.getUniqueId(docId), docData).then(function () {
                    //alert('doc written');
                });
            }

        },
        // ============================================================================= SET CONTNET FROM LOCAL STORAGE END ===========================

        getUniqueId: function (docId) {
            return docId + "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType;
        },

        CheckLocalStorageVersion: function () {

            var deferred = $q.defer();

            CommonLargeLocalStorageFactoryInstance.GetContentInEHRLocalStorage("SchedulerVersionInfo").then(function (serviceResponse) {

                if (isError(serviceResponse) || !CommonLargeLocalStorageFactoryInstance.hasValueInLLS(serviceResponse)) {
                    //NO DATA AVILABLE
                    //SO ADDING DATA
                    CommonLargeLocalStorageFactoryInstance.SetContentInEHRLocalStorage("SchedulerVersionInfo", SchedulersDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                    deferred.resolve("success");
                } else {
                    //Version Info Avialbe and Not Matched with Current Version
                    if (typeof serviceResponse == "string" && (serviceResponse.toString().trim().toUpperCase() != SchedulersDBCurVersionNumber.trim().toUpperCase())) {
                        if (storage.ready()) {
                            storage.clear().then(function () {
                                //console.log('LOCAL STORAGE CLEARED & New Version Details Added to LOCAL STORAGE');
                                CommonLargeLocalStorageFactoryInstance.SetContentInEHRLocalStorage("SchedulerVersionInfo", SchedulersDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                                deferred.resolve("success");
                            });// clear the entire database

                        }
                    } else {
                        deferred.resolve("success");
                    }
                }
            });
            return deferred.promise;
        },

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        GetContentInEHRLocalStorage: function (docId) {



            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve(undefined);
                });
            }
            else {
                if (storage.ready()) {

                    $rootScope.$broadcast("ajax-loader-countincrement");
                    storage.getContents(CommonLargeLocalStorageFactoryInstance.getUniqueId(docId)).then(function (contents) {

                        if (contents == NoDataFromDataBase) {
                            deferred.resolve(NoDataFromDataBase);
                        }
                        else
                            deferred.resolve(contents != undefined && contents != null && contents != "" ? JSON.parse(LZString144.decompressFromUTF16(contents)) : undefined);

                        $rootScope.$broadcast("ajax-loader-countdecrement");

                    }, function (error) {
                        $rootScope.$broadcast("ajax-loader-countdecrement");
                        deferred.resolve(undefined);
                    });
                }
                else {
                    setTimeout(function () {
                        deferred.resolve(undefined);
                    });
                }

                //.error(function (error) {
                //    return undefined;
                //});

            }



            return deferred.promise;
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        GetAllSchedulerIdsInEHRLocalStorage: function () {
            var deferred = $q.defer();
            var SchedulerTemplateIDsInLLS = "";//USED TO HOLD ALL EASY FORM TEMPATE IDS PRESENT IN THE LLS
            var SchedulerTemplateIDsInLLSOfOtherPractice = "";//USED TO HOLD ALL EASY FORM TEMPATE IDS PRESENT IN THE LLS
            var SchedulerTemplatePrefix = "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType;//INDICATES THE PREFIX OF KEY IN LLS

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve(undefined);
                });
            }
            else {

                if (storage.ready()) {
                    storage.ls().then(function (docKeys) {

                        //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                        if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                            for (var index = 0; index < docKeys.length; index++) {

                                docId = docKeys[index];//ASSIGING THE EASY FORM ID

                                if (docId != undefined && docId != null && docId.toString().length > 0) {

                                    if (docId.toString().trim().toLowerCase().indexOf(SchedulerTemplatePrefix) >= 0) {

                                        //VALIDATING TEMPLATE SETTING IS PRESENT OR NOT
                                        if (docId.toString().trim().toLowerCase().indexOf(SchedulertemplateTitle) >= 0) {

                                            //REMOVING SUFFIX
                                            docId = docId.substr(SchedulertemplateTitle.length, docId.length);

                                            //REMOVING PREFIX
                                            if (docId.lastIndexOf(SchedulerTemplatePrefix) == (docId.length - SchedulerTemplatePrefix.length))
                                                docId = docId.substr(0, docId.length - SchedulerTemplatePrefix.length);

                                            SchedulerTemplateIDsInLLS = SchedulerTemplateIDsInLLS + docId + ","
                                        }
                                    }
                                    else {
                                        SchedulerTemplateIDsInLLSOfOtherPractice = SchedulerTemplateIDsInLLSOfOtherPractice + docId + ","
                                    }
                                }
                            }

                            SchedulerTemplateIDsInLLS = SchedulerTemplateIDsInLLS.trim().trimEnd(",");

                            if (hasValue(SchedulerTemplateIDsInLLSOfOtherPractice)) {
                                //CommonLargeLocalStorageFactoryInstance.RemoveInactiveSchedulerEHRLocalStorageAsyncOtherPracticeData(SchedulerTemplateIDsInLLSOfOtherPractice);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                            }

                            deferred.resolve(SchedulerTemplateIDsInLLS);

                        }
                        else {
                            deferred.resolve(undefined);
                        }

                    });
                }

                else {
                    setTimeout(function () {
                        deferred.resolve(undefined);
                    });
                }
            }
            return deferred.promise;
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE START ===========================
        RemoveContentInEHRLocalStorage: function (docId) {
            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                return;
            }

            if (storage.ready()) {

                storage.rm(CommonLargeLocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                    //alert('doc and all attachments were removed');
                });
            }
        },
        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE END ===========================

        RemoveInactiveSchedulerEHRLocalStorageAsyncOtherPracticeData: function (InactiveSchedulerTemplateIDs) {

            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve('success');
                })
            }

            else {
                if (storage.ready()) {

                    if (InactiveSchedulerTemplateIDs != undefined && InactiveSchedulerTemplateIDs != null && InactiveSchedulerTemplateIDs.toString().length > 0) {

                        var docKeys = InactiveSchedulerTemplateIDs.toString().split(',');

                        //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                        if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

                            for (var index = 0; index < docKeys.length; index++) {

                                docId = docKeys[index];//ASSIGING THE EASY FORM ID

                                if (docId != undefined && docId != null && docId.toString().length > 0) {

                                    storage.rm(docId).then(function () {
                                        //alert('doc and all attachments were removed');
                                    });
                                }
                            }
                        }
                    }
                }
                else {
                    setTimeout(function () {
                        deferred.resolve('success');
                    })
                }
            }
            return deferred.promise;
        },

        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        RemoveInactiveSchedulerEHRLocalStorage: function (InactiveSchedulerTemplateIDs) {

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                return;
            }

            if (storage.ready()) {

                if (InactiveSchedulerTemplateIDs != undefined && InactiveSchedulerTemplateIDs != null && InactiveSchedulerTemplateIDs.toString().length > 0) {

                    var docKeys = InactiveSchedulerTemplateIDs.toString().split(',');

                    //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                    if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

                        for (var index = 0; index < docKeys.length; index++) {

                            docId = docKeys[index];//ASSIGING THE EASY FORM ID

                            if (docId != undefined && docId != null && docId.toString().length > 0) {

                                //REMOVING 

                                //1. EASY FORM BINARY DATA
                                CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(SchedulertemplateTitle + docId);
                                //console.log('Easy Form Binary Data removed from LLS...');

                                //2. SETTINGS DATA
                                CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(SchedulerSettingsTitle + docId);
                                //console.log('Easy Form Settings Data removed From LLS...');

                                ////3. GOLDEN THREAD CUST OPTIONS DATA
                                //CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(SchedulertemplateGoldenThreadCustFields + docId);
                                //console.log('Easy Form Golden Thread Custom Fields Data removed From LLS...');

                                //4. GOLDEN THREAD CUST OPTIONS DATA
                                CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(SchedulerDataObjectPropertiesdetails + docId);
                                //console.log('Easy Form Custom Options Data removed From LLS...');

                                //4. GOLDEN THREAD CUST OPTIONS DATA
                                CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(SchedulertemplateCustomOptions + docId);
                                //console.log('Easy Form Custom Options Data removed From LLS...');



                            }
                        }
                    }
                }
            }
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= REMOVE ALL CONTNET IN LOCAL STORAGE START =============================
        RemoveAllContentInEHRLocalStorage: function () {
            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve("success");
                });
            }
            else {
                if (storage.ready()) {

                    storage.ls().then(function (docKeys) {

                        if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                            angular.forEach(docKeys, function (docId, index) {
                                storage.rm(CommonLargeLocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                                    if (index == docKeys.length - 1) {
                                        deferred.resolve("success");
                                    }
                                }, function () {
                                    if (index == docKeys.length - 1) {
                                        deferred.resolve("success");
                                    }
                                });
                            });
                        }
                        else {
                            deferred.resolve("success");
                        }

                    });
                } else {
                    setTimeout(function () {
                        deferred.resolve("success");
                    });
                }
            }


            return deferred.promise;
        },
        // ============================================================================= REMOVE ALL CONTNET IN LOCAL STORAGE END =============================

        RemoveContentInEHRLocalStorageAsync: function (docId) {

            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve('success');
                })
            }
            else {
                if (storage.ready()) {

                    storage.rm(CommonLargeLocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                        deferred.resolve('success');
                    }, function () {
                        deferred.resolve('success');
                    });
                }
                else {
                    setTimeout(function () {
                        deferred.resolve('success');
                    })
                }
            }

            return deferred.promise;
        },

        RemoveInactiveSchedulerEHRLocalStorageAsync: function (InactiveSchedulerTemplateIDs) {

            var deferred = $q.defer();

            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve('success');
                })
            }

            else {
                if (storage.ready()) {

                    if (InactiveSchedulerTemplateIDs != undefined && InactiveSchedulerTemplateIDs != null && InactiveSchedulerTemplateIDs.toString().length > 0) {

                        var docKeys = InactiveSchedulerTemplateIDs.toString().split(',');

                        //LOOPING FOR ALL EASY FORM TEMPLATES IN LLS
                        if (docKeys != null && docKeys != undefined && docKeys.length > 0) {

                            for (var index = 0; index < docKeys.length; index++) {

                                docId = docKeys[index];//ASSIGING THE EASY FORM ID

                                if (docId != undefined && docId != null && docId.toString().length > 0) {

                                    //REMOVING 

                                    //1. EASY FORM BINARY DATA
                                    CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(SchedulertemplateTitle + docId).then(function () {
                                        //console.log('Easy Form - Binary Data removed from LLS...');

                                        //2. SETTINGS DATA
                                        CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(SchedulerSettingsTitle + docId).then(function () {
                                            //console.log('Easy Form - Settings Data removed From LLS...');

                                            //3. Data Object Properties
                                            CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(SchedulerDataObjectPropertiesdetails + docId).then(function () {

                                                //console.log('Easy Form - Data Object Properties details Data removed From LLS...');

                                                //4. CUSTOM OPTIONS OPTIONS DATA
                                                CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(SchedulertemplateCustomOptions + docId).then(function () {

                                                    //console.log('Easy Form - Custom Options Data removed From LLS...');

                                                    //4. GROUP THERAPHY BINARY
                                                    CommonLargeLocalStorageFactoryInstance.RemoveContentInEHRLocalStorageAsync(SchedulertemplateGroupTheraphyTitle + docId).then(function () {

                                                        //console.log('Group Theraphy Easy Form Binary Data removed From LLS...');
                                                        deferred.resolve('success');
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }
                            }
                        }
                    }
                }
                else {
                    setTimeout(function () {
                        deferred.resolve('success');
                    })
                }
            }
            return deferred.promise;
        },

      
        //CheckLocalStorageExistorNotandShowMessage: function (LLSKey, Message) {
          
        //    if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
        //        return;
        //    } else {
        //        setTimeout(function () {
        //            ShowErrorMessage(Message);
        //        }, 50);

        //    }

        //},

        CheckLocalStorageExistorNotandShowMessage: function () {
          
            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                return;
            } else if (!hasValue(storage)) {
                return;
            } else {
                if (storage.ready()) {
                    ShowErrorMessage("Please Reload Easy Form to Apply Changes.");
                }
            }
        },

        CheckIsLocalStorageAvailable: function () {
            if (EHRisMobile.any() || IsLocalStorageNotInitialized) {
                return false;
            } else if (!hasValue(storage)) {
                return false;
            } else {
                return storage.ready();
            }
        },

    };

    return CommonLargeLocalStorageFactoryInstance;
    //==================================================================================== LLS END ========================================================================================
}]);










